const clone = obj => {
  return JSON.parse(JSON.stringify(obj))
}

const testingUrl = 'spectivtesting.site'
const liveUrl = 'www.takemethere.tv'

export { liveUrl as apiUrl, clone }



// WEBPACK FOOTER //
// ./src/js/Utility.js